module.exports = __webpack_public_path__ + "media/aboutus.24b7e43a.mp4";